import { useContext, useEffect } from 'react'
import { CommandCenterStateProviderContext } from '../context';

const useHwil = () => {

    const context = useContext(CommandCenterStateProviderContext);
    if (context === undefined) {
        throw new Error('useContacts must be used within a ContactProvider');
    }

    const { allRemoteApplications, setAllRemoteApplications, remoteConnectionStatus, setRemoteConnectionStatus, remoteConnectionModal, setRemoteConnectionModal, remoteAppLoader, setRemoteAppLoader } = context;


    const close = (event: MouseEvent) => {
        if (event.target instanceof Element) {
            if (event.target.closest('.remote__connect__modal') || event.target.closest('.remote__payload__connect__info__button')) return
            setRemoteConnectionModal(false)
        }
    }
    useEffect(() => {
        document.addEventListener('click', close)
        return () => {
            document.removeEventListener('click', close)
        }
    }, [])

    return {
        remoteAppLoader,
        setRemoteAppLoader,
        allRemoteApplications,
        setAllRemoteApplications,
        remoteConnectionStatus,
        setRemoteConnectionStatus,
        remoteConnectionModal,
        setRemoteConnectionModal,
    }
}

export default useHwil